import React, { RefObject, useEffect, useRef } from "react";
import "./c-dropdown.scss";

function useClickOutsideDropdownListener(ref: RefObject<HTMLElement>, props: DropdownProps) {
  const handleMouseDown = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      event.stopPropagation();
      event.preventDefault();
      if (props.onClickOutsideDropdown) {
        props.onClickOutsideDropdown();
      }
    }
  };

  useEffect(() => {
    const page = document.querySelector(".page");
    if (!page) {
      return () => {};
    }

    if (props.visible) {
      page.addEventListener("click", handleMouseDown);
    }

    return () => {
      page.removeEventListener("click", handleMouseDown);
    };
  }, [props.visible]);
}

interface DropdownProps {
  onClickOutsideDropdown?: () => void;
  visible: boolean;
}

export const Dropdown: React.FC<DropdownProps> = props => {
  const dropdownRef = useRef<HTMLElement>(null);
  let currentTransitionTimeout: NodeJS.Timeout | null;
  const classes = {
    bodyOverlay: "-dropdown-showing",
    dropdownHideMobile: "l-m-hidden",
    dropdownHideDesktop: "u-hide-desktop",
    transitionClass: "c-dropdown__mobile-transition"
  };

  useClickOutsideDropdownListener(dropdownRef, props);

  const updateClassList = (action: "add" | "remove", element: HTMLElement | null, classNames: string[]) => {
    if (element) {
      element.classList[action](...classNames);
    }
  };

  const showTransition = () => {
    if (!currentTransitionTimeout) {
      updateClassList("add", document.body, [classes.bodyOverlay]);
      updateClassList("remove", dropdownRef.current, [classes.dropdownHideMobile, classes.dropdownHideDesktop]);
      currentTransitionTimeout = setTimeout(() => {
        updateClassList("remove", dropdownRef.current, [classes.transitionClass]);
        currentTransitionTimeout = null;
      }, 50);
    }
  };

  const hideTransition = () => {
    if (!currentTransitionTimeout) {
      updateClassList("remove", document.body, [classes.bodyOverlay]);
      updateClassList("add", dropdownRef.current, [classes.transitionClass, classes.dropdownHideDesktop]);
      currentTransitionTimeout = setTimeout(() => {
        updateClassList("add", dropdownRef.current, [classes.dropdownHideMobile]);
        currentTransitionTimeout = null;
      }, 350);
    }
  };

  useEffect(() => {
    if (props.visible) {
      showTransition();
    } else {
      hideTransition();
    }
  }, [props.visible, dropdownRef]);

  return (
    <section ref={dropdownRef} className={`c-dropdown c-dropdown__mobile-transition u-hide-desktop`}>
      {props.children}
    </section>
  );
};
